import Switch from "@mui/material/Switch";
import styled from "styled-components";
import Colors from "../../constants/Colors";

export const StyledSwitch = styled(Switch)`
        width: 70px !important;
        height: 40px !important; 
        

        & .MuiSwitch-thumb{
            color: white;
            margin-left: 6px;
        }

        & .MuiSwitch-switchBase{
            &.Mui-checked{
                & + .MuiSwitch-track{
                    opacity: 1;
                    background-color: ${Colors.SPM500};
                }
            }
        }

        & .MuiSwitch-track{
            background-color: ${Colors.SPM100};
            opacity: 1;
            height: 24px;
            border-radius: 12px;
            margin-top: -5px;
        }
`;



